import { connect } from 'react-redux';
import _ from 'lodash';
import { toMap } from 'src/util/Util';
import { getScreenData, Store, formatMessage, setScreenData, ACTIVE_SCREEN_KEY, copyToClipboard } from 'cw-ui-core';
import setAlertScreenMessage from 'src/asio-neon-components/Utils';
import { ALERT_TYPE } from 'src/asio-neon-components/Constants';
import ConfigureExternalIdP from 'src/features/authentication-v2/components/ConfigureExternalIdP/ConfigureExternalIdP';
import { validateAuthority } from 'src/services/LoginProviderService';
import { v4 as uuidv4 } from 'uuid';
import { setErrorByIndex } from 'src/asio-neon-components/Stepper/utils';
import Locale from 'src/i18n';
import { identityProviderRedirectUri, identityProviderSignoutUri } from 'src/services/ApiService';
import { CONFIGURE_EXTERNAL_IDP_STEP_INDEX } from 'src/features/authentication-v2/constants';

const mapStateToProps = (state, ownProps) => {
    const screenKey = ownProps.screenKey || ACTIVE_SCREEN_KEY;

    const formErrors = toMap(getScreenData(state.screen, ['formErrors'], screenKey));
    const scheme = getScreenData(state.screen, ['identityProvider', 'scheme'], screenKey);
    const isValidAuthorityUrl = getScreenData(state.screen, ['isValidAuthorityUrl'], screenKey);
    const identityProviderExtraFields = toMap(getScreenData(state.screen, ['identityProviderExtraFields'], screenKey));
    const hasSecrets = getScreenData(state.screen, ['identityProvider', 'secretRequired'], screenKey);

    return {
        formErrors,
        scheme,
        isValidAuthorityUrl,
        identityProviderExtraFields,
        hasSecrets,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const screenKey = ownProps.screenKey || ACTIVE_SCREEN_KEY;
    return {
        onDidMount: () => {
            let scheme = getScreenData(Store().getState().screen, ['identityProvider', 'scheme'], screenKey);

            if (!scheme) {
                scheme = uuidv4();
            }

            dispatch(
                setScreenData(
                    ['identityProviderExtraFields', 'redirectUri'],
                    identityProviderRedirectUri(scheme),
                    screenKey
                )
            );
            dispatch(
                setScreenData(
                    ['identityProviderExtraFields', 'logoutUri'],
                    identityProviderSignoutUri(scheme),
                    screenKey
                )
            );
        },
        onCopy: data => {
            copyToClipboard(data);
            dispatch(
                setAlertScreenMessage(
                    ALERT_TYPE.success,
                    '',
                    formatMessage(Locale.copyClipboardMessage, { data }),
                    true,
                    screenKey
                )
            );
        },
        onUpdateClientSecret: secret => {
            dispatch(setScreenData(['clientSecrets'], secret, screenKey));
        },
        onTestConfiguration: () => {
            const identityProvider = getScreenData(Store().getState().screen, ['identityProvider'], screenKey).toJS();
            Store().runSaga(validateAuthority, identityProvider.authority, screenKey);
        },
        validateField: field => {
            const fieldValue = getScreenData(Store().getState().screen, ['identityProvider', field], screenKey);
            const errorMessage =
                _.isEmpty(fieldValue) || !_.trim(fieldValue) ? formatMessage(Locale.requiredFieldError) : '';
            dispatch(setScreenData(['formErrors', field], errorMessage, screenKey));
            const formErrors = toMap(getScreenData(Store().getState().screen, ['formErrors'], screenKey));

            const isError = _.some(formErrors, val => !_.isEmpty(val));
            setErrorByIndex(CONFIGURE_EXTERNAL_IDP_STEP_INDEX, isError, 'errors', screenKey);
        },
        resetConfigurationValidity: () => {
            dispatch(setScreenData('isValidAuthorityUrl', null, screenKey));
        },
    };
};

const ConfigureExternalIdPContainer = connect(mapStateToProps, mapDispatchToProps)(ConfigureExternalIdP);

export default ConfigureExternalIdPContainer;
